import { useState, useRef } from "react";
import { Upload, X, Loader2, ImageIcon } from "lucide-react";
import api from "../lib/api";

export function ImageUpload({ onUpload, currentUrl, className = "" }) {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(currentUrl || null);
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const localPreview = URL.createObjectURL(file);
    setPreview(localPreview);
    setUploading(true);

    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await api.post("/upload/image", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const url = res.data.url;
      setPreview(url);
      onUpload(url);
    } catch (err) {
      setPreview(null);
      alert(err.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const clear = () => {
    setPreview(null);
    onUpload("");
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <div className={className}>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid="image-upload-input" />
      {preview ? (
        <div className="relative rounded-xl overflow-hidden border border-slate-200 bg-slate-50">
          <img src={preview.startsWith("blob:") ? preview : (preview.startsWith("http") ? preview : `${process.env.REACT_APP_BACKEND_URL}${preview}`)} alt="Preview" className="w-full h-40 object-cover" />
          {uploading && (
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
              <Loader2 className="h-6 w-6 text-white animate-spin" />
            </div>
          )}
          <button onClick={clear} className="absolute top-2 right-2 bg-white/80 hover:bg-white rounded-full p-1 shadow" data-testid="image-remove-btn">
            <X className="h-4 w-4 text-slate-600" />
          </button>
        </div>
      ) : (
        <button
          onClick={() => inputRef.current?.click()}
          data-testid="image-upload-btn"
          className="w-full h-28 border-2 border-dashed border-slate-200 rounded-xl flex flex-col items-center justify-center gap-2 text-slate-400 hover:border-[#0B6E4F] hover:text-[#0B6E4F] transition-colors cursor-pointer"
        >
          <ImageIcon className="h-6 w-6" />
          <span className="text-xs font-medium">Click to upload image</span>
        </button>
      )}
    </div>
  );
}
